export const initialState: any = {
    IntegratorId: "",
    IntegratorName: "",
    Comment: "",
    AssignedParkingLot: -1
}